var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_30956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 21.1255V37.1255C43.5 38.1863 43.0786 39.2037 42.3284 39.9539C41.5783 40.704 40.5609 41.1255 39.5 41.1255H9.5C8.43913 41.1255 7.42172 40.704 6.67157 39.9539C5.92143 39.2037 5.5 38.1863 5.5 37.1255V11.1255C5.5 10.0646 5.92143 9.04718 6.67157 8.29703C7.42172 7.54688 8.43913 7.12546 9.5 7.12546H29.5M17.5 7.12546V41.1255",
    stroke: "#523FF6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 7.12546C37.5 8.22646 37.5 13.1255 31.5 13.1255C32.601 13.1255 37.5 13.1255 37.5 19.1255C37.5 13.1255 42.399 13.1255 43.5 13.1255C37.5 13.1255 37.5 8.22646 37.5 7.12546ZM30 23C30 23.734 30 27 26 27C26.734 27 30 27 30 31C30 27 33.266 27 34 27C30 27 30 23.734 30 23Z",
    stroke: "#523FF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_30956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.125458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveBack);
export default __webpack_public_path__ + "static/media/give-back.754fb9ff93d63eebadce277cc814de2b.svg";
export { ForwardRef as ReactComponent };